// Exposed libraries
require('expose-loader?jQuery!jquery');
require('expose-loader?$!jquery'); // for yii2 widgets that use $
//require('expose-loader?Swiper!./node_modules/swiper/dist/js/swiper.js');
require('expose-loader?toastr!toastr');
require('expose-loader?Cookies!js-cookie');
